import type { ReactNode } from "react";

import Header from "../../components/Header/Header";

import { useAuth } from "../../auth/AuthContext";

import "./MainLayout.css";

type MainLayoutProps = {
  children: ReactNode;
};

export default function MainLayout({
  children,
}: MainLayoutProps) {
  const {
    profile,
    logout,
  } = useAuth();

  const firstName =
    profile?.nome?.trim().split(" ")[0] ||
    "Usuário";

  async function handleLogout() {
    await logout();
  }

  return (
    <div className="main-layout">
      <Header
        title="SUNSET ONE"
        user={firstName}
        online
        onLogout={handleLogout}
      />

      <main className="main-content">
        {children}
      </main>
    </div>
  );
}